<template>
  <!--单个商品组件（竖向排序，可换行）-->
  <tk-flex
    class="full-width"
    style="position: relative;"
  >
    <div>
      <div
        class="class-recommended-img commodity-single-image"
        :style="{ width: imageSize + 'px' }"
      >
        <tk-image
          class="class-recommended-image"
          :src="commodity.showPictures[0]"
          :width="imageSize" :height="imageSize"></tk-image>
      </div>
    </div>
    <tk-flex
      :style="{minHeight: imageSize + 'px'}"
      style="position: relative;"
      class="m-l-15 van-flex-row"
      column>
      <tk-flex
        middle
        class="full-width m-t-12"
      >
        <div
          style="width: 35px;flex-shrink:0;"
        >
          <tk-flex
            center
            v-if="commodity.selfAndSelected"
            style="line-height: 17px;"
            class="commodity-title-label">
            <div>
              {{commodity.selfAndSelected | titleLabel}}
            </div>
          </tk-flex>
        </div>
        <div class="font-14 van-ellipsis van-flex-row">{{commodity.productTitle}}</div>
      </tk-flex>
      <tk-flex
        middle
        style="position: absolute;bottom: 12px;"
        class="m-t-5"
      >
        <div class="font-14 text-light-grey m-b-2">订单金额</div>
        <div
          style="font-size: 15px;"
          class="m-l-10"
        >
          <span class="font-10">￥</span>{{ amount }}
        </div>
      </tk-flex>
    </tk-flex>
  </tk-flex>
</template>

<script>
export default {
  props: {
    commodity: {
      type: Object
    },
    imageSize: {
      type: Number,
      default: 130
    },
    amount: {
      type: Number,
      default: 0
    }
  },
  filters: {
    titleLabel (val) {
      return val === 'self' ? '自营' : '精选'
    }
  }
}
</script>

<style lang="scss" scoped>
  /*图片的修饰*/
  .commodity-single-image {
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    .closed-css-invalid {
      position: absolute;
      top: 0;
      left: 0;
      padding: 3px;
      background-color: rgba(0, 0, 0, 0.1);
      font-size: 12px;
      color: #cecece;
    }
  }
</style>
